import React from "react";

const NodeHeroSvg = () => {
  return (
    <svg
      width="374"
      height="217"
      viewBox="0 0 384 219"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Nodes</title>
      <g filter="url(#filter0_d_4648_18216)">
        <circle
          cx="39"
          cy="87"
          r="5"
          transform="rotate(180 39 87)"
          fill="#5663F2"
        />
      </g>
      <g filter="url(#filter1_d_4648_18216)">
        <circle
          cx="148"
          cy="49"
          r="5"
          transform="rotate(180 148 49)"
          fill="#5663F2"
        />
      </g>
      <g filter="url(#filter2_d_4648_18216)">
        <circle
          cx="62"
          cy="137"
          r="5"
          transform="rotate(180 62 137)"
          fill="#5663F2"
        />
      </g>
      <g filter="url(#filter3_d_4648_18216)">
        <circle
          cx="15"
          cy="167"
          r="5"
          transform="rotate(180 15 167)"
          fill="#5663F2"
        />
      </g>
      <g filter="url(#filter4_d_4648_18216)">
        <circle
          cx="225"
          cy="120"
          r="5"
          transform="rotate(180 225 120)"
          fill="#5663F2"
        />
      </g>
      <g filter="url(#filter5_d_4648_18216)">
        <circle
          cx="168"
          cy="199"
          r="5"
          transform="rotate(180 168 199)"
          fill="#5663F2"
        />
      </g>
      <g filter="url(#filter6_d_4648_18216)">
        <circle
          cx="62"
          cy="20"
          r="5"
          transform="rotate(180 62 20)"
          fill="#5663F2"
        />
      </g>
      <g filter="url(#filter7_d_4648_18216)">
        <circle
          cx="147"
          cy="175"
          r="5"
          transform="rotate(180 147 175)"
          fill="#5663F2"
        />
      </g>
      <path
        d="M384 1H350C341.716 1 335 7.71573 335 16V203C335 211.284 341.716 218 350 218H384"
        stroke="url(#paint0_linear_4648_18216)"
      />
      <path
        d="M334.5 37L287.213 37C283.235 37 279.42 35.4197 276.607 32.6066L268.393 24.3934C265.58 21.5804 261.765 20 257.787 20L62 20"
        stroke="#5663F2"
      />
      <path
        d="M334.5 192L287.213 192C283.235 192 279.42 190.42 276.607 187.607L268.393 179.393C265.58 176.58 261.765 175 257.787 175L147 175"
        stroke="#5663F2"
      />
      <path
        d="M334.5 154L190.213 154C186.235 154 182.42 152.42 179.607 149.607L171.393 141.393C168.58 138.58 164.765 137 160.787 137L62 137"
        stroke="#5663F2"
      />
      <path
        d="M335 66.5L236.713 66.5C232.735 66.5 228.92 64.9197 226.107 62.1066L217.893 53.8934C215.08 51.0804 211.265 49.5 207.287 49.5L148 49.5"
        stroke="#5663F2"
      />
      <path
        d="M30 87L247.787 87C251.765 87 255.58 85.4197 258.393 82.6066L270.107 70.8934C272.92 68.0804 276.735 66.5 280.713 66.5L335 66.5"
        stroke="#5663F2"
      />
      <path
        d="M15 167L82.8593 167C86.7946 167 90.5723 165.453 93.3779 162.694L115.122 141.306C117.928 138.547 121.705 137 125.641 137L159 137"
        stroke="#5663F2"
      />
      <path
        d="M335 95.5L302.213 95.5C298.235 95.5 294.42 97.0804 291.607 99.8934L275.893 115.607C273.08 118.42 269.265 120 265.287 120L225.5 120"
        stroke="#5663F2"
      />
      <path
        d="M249 175L232.925 175C229.012 175 225.254 176.529 222.453 179.261L206.579 194.739C203.778 197.471 200.02 199 196.107 199L168 199"
        stroke="#5663F2"
      />
      <defs>
        <filter
          id="filter0_d_4648_18216"
          x="24.4"
          y="72.4"
          width="29.2"
          height="29.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.337255 0 0 0 0 0.388235 0 0 0 0 0.94902 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4648_18216"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4648_18216"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_4648_18216"
          x="133.4"
          y="34.4"
          width="29.2"
          height="29.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.337255 0 0 0 0 0.388235 0 0 0 0 0.94902 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4648_18216"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4648_18216"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_4648_18216"
          x="47.4"
          y="122.4"
          width="29.2"
          height="29.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.337255 0 0 0 0 0.388235 0 0 0 0 0.94902 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4648_18216"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4648_18216"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_4648_18216"
          x="0.4"
          y="152.4"
          width="29.2"
          height="29.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.337255 0 0 0 0 0.388235 0 0 0 0 0.94902 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4648_18216"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4648_18216"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_4648_18216"
          x="210.4"
          y="105.4"
          width="29.2"
          height="29.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.337255 0 0 0 0 0.388235 0 0 0 0 0.94902 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4648_18216"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4648_18216"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_4648_18216"
          x="153.4"
          y="184.4"
          width="29.2"
          height="29.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.337255 0 0 0 0 0.388235 0 0 0 0 0.94902 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4648_18216"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4648_18216"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_4648_18216"
          x="47.4"
          y="5.4"
          width="29.2"
          height="29.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.337255 0 0 0 0 0.388235 0 0 0 0 0.94902 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4648_18216"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4648_18216"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_4648_18216"
          x="132.4"
          y="160.4"
          width="29.2"
          height="29.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.337255 0 0 0 0 0.388235 0 0 0 0 0.94902 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4648_18216"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4648_18216"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4648_18216"
          x1="384"
          y1="109.5"
          x2="335"
          y2="109.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5663F2" stopOpacity="0" />
          <stop offset="1" stopColor="#5663F2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NodeHeroSvg;
